import videoType from '@/enums/videoType'

export function extname(filename) {
  if (!filename || typeof filename !== 'string') {
    return false
  }
  const a = filename.split('').reverse().join('')
  return a.substring(0, a.search(/\./)).split('').reverse().join('').toLowerCase()
}

export function vType(url) {
  const name = extname(url) || 'mp4'
  return videoType.find((item) => item.name === name).type
}

export function cancelReq() {
  const cancelArr = window.axiosCancel
  cancelArr.forEach((ele, index) => {
    ele.cancel('取消了请求') // 在失败函数中返回这里自定义的错误信息
    delete window.axiosCancel[index]
  })
}

const cubic = (value) => Math.pow(value, 3)
const easeInOutCubic = (value) =>
  value < 0.5 ? cubic(value * 2) / 2 : 1 - cubic((1 - value) * 2) / 2
// 回到顶部
export const BackTop = () => {
  const el = document.documentElement
  const beginTime = Date.now()
  const beginValue = el.scrollTop
  const rAF = window.requestAnimationFrame || ((func) => setTimeout(func, 16))
  const frameFunc = () => {
    const progress = (Date.now() - beginTime) / 500
    if (progress < 1) {
      el.scrollTop = beginValue * (1 - easeInOutCubic(progress))
      rAF(frameFunc)
    } else {
      el.scrollTop = 0
    }
  }
  rAF(frameFunc)
}

// 对象 转化 queryStr
export function Obj2Str(obj) {
  let str = ''
  for (const i in obj) {
    str += `&${i}=${obj[i]}`
  }
  return str ? str.slice(1) : ''
}

function isIE() {
  if (!!window.ActiveXObject || 'ActiveXObject' in window) return true
  else return false
}

export const useTim = () => {
  const userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
  const isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
  const ie = isIE()
  return isIE11 || !ie
}

// 生成指定范围的随机数
export const getRandom = function(n, m) {
  return Math.floor(Math.random() * (m - n + 1) + n)
}

export function convertImgToBase64(url) {
  return new Promise((resolve) => {
    let canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    const img = new Image()
    img.crossOrigin = 'Anonymous'
    img.onload = function() {
      if (canvas) {
        canvas.height = img.height
        canvas.width = img.width
        ctx.drawImage(img, 0, 0)
        const dataURL = canvas.toDataURL('image/png')
        resolve(dataURL)
      }
      canvas = null
    }
    img.src = url
  })
}

export const checkNumPhone = (phone) => {
  const reg = /^\d+$/
  return reg.test(phone)
}
